import View from 'ln/view/View';
import Signal from 'ln/signal/Signal';
import Node from 'ln/node/Node';
import Template from 'ln/template/TemplateManager';
import { ISlide } from './SlideDetailView';
import SlideDetailView from './SlideDetailView';

export interface SlidePreviewCallback{
	( slide:ISlide );
}

class SlidePreview extends View{
	
	public selected:Signal<SlidePreviewCallback>;
	
	constructor( public slide:ISlide ){
		super( { template: 'krw.slide-preview' } );
		this.selected = new Signal<SlidePreviewCallback>();
	}
	
	public init(){
		
		var content = new SlideDetailView();
		content.setSlide( this.slide )
		content.render();
		content.node.addClass( 'slide-preview' );
		content.node.removeClass( 'krw-box' );
		content.node.removeClass( 'krw-shadow' );
		this.node.js( 'slide' ).append( content.node );
		
		this.node.click.add( this.onSelect, this );
		
	}
	
	private onSelect(){
		this.selected.dispatch( this.slide );
	}
}

export default SlidePreview;